export default "__VITE_ASSET__BDVon1xf__"